export default "/images/vendor/flag-icon-css/flags/1x1/bz.svg?7826f0d58900985ad3120f3a0b8451dd";